/**
 * free-tester.js - Random tester that shows real name in cart
 */
(function() {

  const interval = setInterval(() => {

    const addToCartButton = document.querySelector('[data-atc-form]');
    const productSelect = document.querySelector('select[name="id"]');
    const testerWrapper = document.getElementById('tester-wrapper');
    const testerSelect = document.getElementById('tester-select');

    if (!addToCartButton || !productSelect || !testerWrapper || !testerSelect) return;

    clearInterval(interval);

    function eligibleVariant() {
      const text = productSelect.options[productSelect.selectedIndex].text;
      return text.includes('50ML') || text.includes('100ML');
    }

    function toggleTester() {
      testerWrapper.style.display = eligibleVariant() ? 'block' : 'none';
    }

    toggleTester();
    productSelect.addEventListener('change', toggleTester);

    addToCartButton.addEventListener('click', function(e) {

      if (!eligibleVariant()) return;

      const form = addToCartButton.closest('form');

      // remove old property if exists
      const old = form.querySelector('input[name="properties[Free Gift]"]');
      if (old) old.remove();

      let selectedValue = testerSelect.value;

      // 🔥 If Random selected → replace with actual random tester
      if (selectedValue.includes('Random tester fun!')) {

        const realOptions = Array.from(testerSelect.options).slice(1); 
        const randomIndex = Math.floor(Math.random() * realOptions.length);
        selectedValue = realOptions[randomIndex].value;
      }

      // Inject final tester name (real one)
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[Free Gift]';
      input.value = selectedValue;
      form.appendChild(input);

      // Kalles AJAX support
      if (window.T4S && window.T4S.addToCart) {
        setTimeout(() => {
          window.T4S.addToCart(addToCartButton);
        }, 50);
        e.preventDefault();
      }

    });

  }, 100);

})();